import { withDefaults } from '@warp-drive/legacy/model/migration-support';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Type } from '@warp-drive/core/types/symbols';

export type Mention = WithLegacy<{
  season: number | null;
  quote: string | null;
  summary: string | null;
  mentionTimestamp: number | null;
  sentiment: number | null;
  sentimentPolarity: string | null;
  sentimentLabel: string | null;
  provider: string | null;
  originalTitle: string | null;
  intent: string | null;
  extractedType: string | null;
  alternativeType: string | null;
  location: string | null;
  personSubtype: string | null;
  musicSubtype: string | null;
  placeSubtype: string | null;
  brandSubtype: string | null;
  productSubtype: string | null;
  suggestedCorrectionId: string | null;
  mentionYear: number | null;
  contentYear: number | null;
  mentionCount: number | null;
  createdAt: string | null;
  updatedAt: string | null;
  item: import('./item.ts').Item | null;
  contentSource: import('./content-source.ts').ContentSource | null;
  [Type]: 'mentions';
}>;

export const MentionSchema = withDefaults({
  type: 'mentions',
  fields: [
    { name: 'season', kind: 'attribute', type: 'number' },
    { name: 'quote', kind: 'attribute', type: 'string' },
    { name: 'summary', kind: 'attribute', type: 'string' },
    { name: 'mentionTimestamp', kind: 'attribute', type: 'number' },
    { name: 'sentiment', kind: 'attribute', type: 'number' },
    { name: 'provider', kind: 'attribute', type: 'string' },
    { name: 'originalTitle', kind: 'attribute', type: 'string' },
    { name: 'intent', kind: 'attribute', type: 'string' },
    { name: 'extractedType', kind: 'attribute', type: 'string' },
    { name: 'alternativeType', kind: 'attribute', type: 'string' },
    { name: 'location', kind: 'attribute', type: 'string' },
    { name: 'personSubtype', kind: 'attribute', type: 'string' },
    { name: 'musicSubtype', kind: 'attribute', type: 'string' },
    { name: 'placeSubtype', kind: 'attribute', type: 'string' },
    { name: 'brandSubtype', kind: 'attribute', type: 'string' },
    { name: 'productSubtype', kind: 'attribute', type: 'string' },
    { name: 'suggestedCorrectionId', kind: 'attribute', type: 'string' },
    { name: 'mentionYear', kind: 'attribute', type: 'number' },
    { name: 'contentYear', kind: 'attribute', type: 'number' },
    { name: 'mentionCount', kind: 'attribute', type: 'number' },
    { name: 'sentimentPolarity', kind: 'attribute', type: 'string' },
    { name: 'sentimentLabel', kind: 'attribute', type: 'string' },
    { name: 'createdAt', kind: 'attribute', type: 'string' },
    { name: 'updatedAt', kind: 'attribute', type: 'string' },
    {
      name: 'item',
      kind: 'belongsTo',
      type: 'items',
      options: { async: false, inverse: null },
    },
    {
      name: 'contentSource',
      kind: 'belongsTo',
      type: 'content-sources',
      options: { async: false, inverse: null },
    },
  ],
});
